module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BarChart"
  }, [_c('svg', {
    ref: "svg",
    staticClass: "BarChart-svg",
    attrs: {
      "width": "534",
      "height": "412"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c81fc50"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/BarChart.vue
// module id = 796
// module chunks = 1